import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";
import Header from "../Header";
import Input from "../Input/Input";

const MerchantForm = () => {
  const navigate = useNavigate();
  const { merchantId } = useParams();

  const [formData, setFormData] = useState({
    merchantName: "",
    seasonId: "",
  });

  useEffect(() => {
    if (merchantId) {
      (async () => {
        const response = await axios.post(`${settings.api}merchants/view`, {
          merchantId: merchantId,
        });

        if (response.data.data) {
          setFormData(response.data.data[0]);
        }
      })();
    }
  }, [merchantId]);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      dir="rtl"
      onSubmit={async (e) => {
        e.preventDefault();

        const response = await axios.post(
          `${settings.api}merchants/${merchantId ? "update" : "create"}`,
          formData,
        );

        if (response.data.statusCode === 200) {
          navigate("/merchants");
        }
      }}
    >
      <div className="w-full">
        <Header title="استماره التاجر" />

        <div className="flex flex-col w-full lg:w-1/2 m-auto gap-4">
          <Input
            label="اسم التاجر"
            value={formData.merchantName}
            onChange={onChange}
            name="merchantName"
          />

          <Button
            className="w-1/2 m-auto"
            type="submit"
            text="تسجيل"
            isDisabled={!formData.merchantName}
          />
        </div>
      </div>
    </form>
  );
};

export default MerchantForm;
